module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQJJREFUOBGtlLsNAjEQRA0BESk0QQHkRykUREIEPVAAEhklQAMEiBCJmM88y3s663xnIxhphLU7MzZrg3NtzFRaiWfxEciaGr0sRlKsxaf47iA9NGiToHEQCXiJG3EujgNZU6OHBm0yjF0QXMVK7MJCDTRo8UTge3NkdusLMRMatHiimTFEduDopUCLB28NboQicygFWjx4a3DFFBlsKdDiwesxtMWvnwRdQkg0uEywac3rCNoH0zJjbrZNa17f+9v1k1b6ICtpbyKD3ootfPsTsauftJJUIIyT8WIRpkiPk9jbO2mdDFPdP/vc3whmQtisN0z9LJphx0FW3i+Yqr0T7x+RR1s1yWv2YQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_search_black.png
// module id = INTR
// module chunks = 1